module.exports = __webpack_public_path__ + "media/images/web_suite/x_close-ad5c5f859e8488028ca7700fea570801.png";